/**
 * @module web/store
 * @private
 */

import { cache } from "../persistence/cache";

let localUser = null;

const update = function(user) {
  localUser = user;
  if (this.localCache && this.localCache.auth) {
    cache.set("user", user, {
      database: "auth",
      expiresIn: this.userCacheTime
    });
  }
};
/**
 * Returns the current session globalUserId, if any. The id will be searched in memory first and local cache as second
 * option.
 * @returns {string} - A found globalUserId or null if none memory nor cache have a valid one.
 */
const get = async function() {
  let cachedUser = null;
  if (this.localCache && this.localCache.auth) {
    cachedUser = await cache.get("user", { database: "auth" });
  }
  if (!localUser && cachedUser) {
    localUser = cachedUser;
  }
  return localUser;
};

export default { update, get };
